import {REQUESTS, request} from "@/main";
import {getCookie} from "@/shared/lib/utils/cookie";
import {useRouter} from "vue-router";
import {UserModel} from "@/entities/User";

export function useInitPresets() {
    const {push} = useRouter();
    const userStore = UserModel.useUserStore();

    if (!localStorage.getItem('refresh_token') && getCookie('GATEWAY')) {
        userStore.getRefreshToken();
    }

    const onFulfilled = async (config: any) => {
        const expireTime = parseInt(localStorage.getItem('expires_in') ?? '');
        if (expireTime <= new Date().getTime()) {
            try {
                await userStore.refreshAuthToken(localStorage.getItem('refresh_token') ?? '');
            } catch (error: any) {
                if (error.response && error.response.status === 403) {
                    userStore.logout();
                    await push({ name: 'main' });
                }
            }
        }
        // if (!config.url.includes("file") && !config.url.includes("storage") && !config.url.includes("user-info"))
        //     userStore.isLoader = true;

        let token = '';

        if (import.meta.env.MODE === 'production') {
            token = getCookie('GATEWAY') ?? '';
        } else {
            token = localStorage.getItem('token') ?? '';
        }
        if (token) {
            config.headers.common['Authorization'] = 'Bearer ' + token
        }
        return config
    }

    const onRejected = (error: any) => {
        userStore.isLoader = false;
        if (!error?.response) {
            return Promise.reject(error);
        }
        if (error?.response?.status === 401) {
            setTimeout(async () => {
                userStore.logout();
                await push({ name: 'main' });
            }, 0);
        }
        return Promise.reject(error)
    };

    REQUESTS.interceptors.response.use(
        (response) => {
            userStore.isLoader = false;
            return response
        },
        onRejected
    );
    request.interceptors.response.use(
        (response) => {
            userStore.isLoader = false;
            return response
        },
        onRejected
    );
    REQUESTS.interceptors.request.use(onFulfilled);
    request.interceptors.request.use(onFulfilled);
    const initAuthPresets = async () => {
        const token = getCookie('GATEWAY');
        if (token) {
            localStorage.setItem('token', token);
        }
        if (localStorage.getItem('token') != null && localStorage.getItem("token") !== undefined) {
            await userStore.getUserData();
        }
    }
    return {initAuthPresets}
}